"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductEditorContainer = void 0;
const react_1 = __importDefault(require("react"));
const product_editor_component_1 = require("./product-editor.component");
const ProductEditorContainer = () => react_1.default.createElement(product_editor_component_1.ProductEditor, null);
exports.ProductEditorContainer = ProductEditorContainer;
exports.default = exports.ProductEditorContainer;
